<a [href]="translate('consumer_logo_url', 'https://kaonline.dk/')">
  <img [src]="consumerFile('logos/main.png')" />
</a>
